"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Accordian = void 0;
exports.hasAccordian = hasAccordian;
var config_1 = require("../config");
var get_closest_1 = require("../helper/get-closest");
var Accordian = /*#__PURE__*/function () {
  function Accordian() {
    var _this = this;
    _classCallCheck(this, Accordian);
    this.accordianToggles = null;
    this.accordianWrapper = null;
    this.accordianItems = null;
    this.padding = window.innerWidth > config_1.CONFIG.variables.width.medium ? 60 : 30;
    this.accordianToggles = document.querySelectorAll(config_1.CONFIG.accordian.toggle);
    this.accordianItems = document.querySelectorAll(config_1.CONFIG.accordian.item);
    if (this.accordianToggles.length > 0) {
      [].forEach.call(this.accordianToggles, function (accordianToggle) {
        accordianToggle.addEventListener('click', _this.toggleAccordian.bind(_this));
      });
    }
  }
  return _createClass(Accordian, [{
    key: "toggleAccordian",
    value: function toggleAccordian(event) {
      var _this2 = this;
      event.preventDefault();
      var accordianItemToggled = (0, get_closest_1.getClosest)(config_1.CONFIG.accordian.item, event.target);
      if (this.accordianItems.length > 0) {
        [].forEach.call(this.accordianItems, function (accordianItem) {
          var outerWrapper = accordianItem.querySelector(config_1.CONFIG.accordian.itemOuterWrapper);
          var innerWrapper = accordianItem.querySelector(config_1.CONFIG.accordian.itemInnerWrapper);
          if (accordianItem === accordianItemToggled) {
            accordianItem.classList.toggle(config_1.CONFIG.accordian.activeClass);
            if (accordianItem.classList.contains(config_1.CONFIG.accordian.activeClass)) {
              outerWrapper.style.maxHeight = innerWrapper.scrollHeight + _this2.padding + 'px';
            } else {
              outerWrapper.style.maxHeight = '0';
            }
          } else {}
        });
      }
    }
  }]);
}();
exports.Accordian = Accordian;
function hasAccordian() {
  if (document.querySelectorAll(config_1.CONFIG.accordian.main).length > 0) {
    return true;
  }
  return false;
}